import React from "react";
import NppHero from "./shared/NppHero";
import { css } from "@emotion/css";
import Page from "./shared/Page";
import WarningBox from "./WarningBox";
import { useIncidentMessage } from "../store/incidentMesage";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { useAuth } from "oidc-react";
import { signInAndTryRemainOnCurrentPathArgs } from "../store/authentication";

const Home: React.FC = () => {
  const { incidentMessage, publishedDate } = useIncidentMessage();
  const auth = useAuth();
  return (
    <Page>
      <NppHero
        title="Nuuday Partner Portal"
        subtitle="Find relevant partnermateriale, dokumentation og kundeinformationer fra Nuuday Mobile Partners"
      />

      <section className="section">
        <div className="content-container">
          {incidentMessage && (
            <WarningBox publishedDate={publishedDate} title="Driftsforstyrrelse">
              {documentToReactComponents(incidentMessage)}
            </WarningBox>
          )}

          <div className="columns">
            <div key="Login til DAWN Partner Portal" className="column">
              <div
                className={
                  "box is-fullheight is-flex is-flex-direction-column is-justify-content-space-around px-5 " +
                  css("background-color: #6E6DCE !important;")
                }
              >
                <p className="is-size-6 has-text-weight-bold has-text-white pb-6">DAWN Partner Portal</p>
                <a
                  className={
                    "button is-rounded is-size-7 has-text-white my-2 has-text-weight-bold " +
                    css("background-color:inherit !important;  border-color: white !important;")
                  }
                  href={`${process.env.REACT_APP_ENV === "production" ? "https://selfservice.nuudaypartnerportal.dk" : "http://nd-cloud-partner-portal-e2e03-bss.non-prod04.nc.nuuday.nu/"}`}
                >
                  Log ind
                </a>
              </div>
            </div>
            <div key="Login til Legacy Partner Portal" className="column">
              <div
                className={
                  "box is-fullheight is-flex is-flex-direction-column is-justify-content-space-around px-5 " +
                  css("background-color: #77b58d !important;")
                }
              >
                <p className="is-size-6 has-text-weight-bold has-text-white pb-6">Legacy Partner Portal</p>
                <button
                  className={
                    "button is-rounded is-size-7 is-outlined has-text-white my-2 has-text-weight-bold " +
                    css("background-color: inherit!important; border-color: white !important;")
                  }
                  onClick={() => auth.signIn(signInAndTryRemainOnCurrentPathArgs())}
                >
                  Log ind
                </button>
              </div>
            </div>
            <div key="Legacy NABS SP Web" className="column">
              <div
                className={
                  "box is-fullheight is-flex is-flex-direction-column is-justify-content-space-around px-5 " +
                  css("background-color: #77b58d!important;")
                }
              >
                <p className="is-size-6 has-text-white pb-6 has-text-weight-bold">Legacy NABS SP Web</p>
                <a
                  className={
                    "button is-rounded is-size-7 has-text-white my-2 has-text-weight-bold " +
                    css("background-color: inherit!important; border-color: white !important;")
                  }
                  href="https://spportal.tdc.dk/spportal/jsp/index.jsp"
                >
                  Log ind
                </a>
              </div>
            </div>
          </div>
          <div className="columns">
            <div key="Driftsinformation" className="column">
              <div className="box is-fullheight is-flex is-flex-direction-column px-5">
                <p className="is-size-6 has-text-weight-semibold">Driftsinformation</p>
                <p className="is-size-7 py-4">Få overblik over planlagte og akutte driftsforstyrrelser på mobilnetværket.</p>
                <a href="/operations/information" className="has-cta is-size-7 is-link">
                  Gå til Driftsinformation
                </a>
              </div>
            </div>
            <div key="Dækningskort" className="column">
              <div className="box is-fullheight is-flex is-flex-direction-column px-5">
                <p className="is-size-6 has-text-weight-semibold">Dækningskort</p>
                <p className="is-size-7 py-4">Her får du en oversigt over dækning af 3G, 4G, 5G og tale i Danmark.</p>
                <a href="/operations/coverage-map" className="is-size-7">
                  Gå til Dækningskort
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="content-container my-6 bg-white">
          <div className="box is-align-items-center has-text-centered px-6">
            <p className="is-size-5 has-text-weight-semibold">Kontakt Nuuday Mobile Partners</p>
            <p className="is-size-7 py-4">
              Vi hjælper dig med at få mest muligt ud af de mobilprodukter, løsninger og systemer, vi stiller til rådighed.
            </p>
            <div className="columns is-size-7">
              <span className="column">
                <p className="is-size-8">Telefon</p>
                <p className="has-text-weight-semibold">
                  <a href="tel:+4570104600">+45 70 10 46 00</a>
                </p>
              </span>
              <span className="column">
                <p className="is-size-8">Email</p>
                <p className="has-text-weight-semibold">
                  <a href="mailto:nmp-ks@nuuday.dk">nmp-ks@nuuday.dk</a>
                </p>
              </span>
            </div>
            <p className="is-size-8">mandag - torsdag 08:00 - 16:00, fredag 08:00 - 15:00</p>
          </div>
        </div>
      </section>
    </Page>
  );
};

export default Home;
